import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button from 'components/Button';
import FieldControl from 'components/Form/FieldControl';
import { uuid } from 'utils/dom';

const getUuid = uuid();

/**
 * VehicleClassFilterCTA Description:
 *
 * @param {object} props - React Props
 * @param {string} props.name: unique field name
 * @param {string} props.id - unique field id
 * @param {string} props.label - a descriptive label for the user to read,
 * @param {string} props.value - shows list of vehicles selected, default value will be AllVehicles,
 * @param {boolean} props.fill - will make the field fill the width of its container
 * @param {boolean} props.required - Show required State
 * @param {boolean} props.disabled - Flag to disable the complete Button, will be marked as a readable state
 * @param {function} props.onChange - Handler for open the VehicleClassFilter Modal
 * @return {JSX} ...
 */

const VehicleClassFilterCTA = (props) => {
  const { name, value, onChange, readOnly } = props;
  return (
    <FieldControl id={getUuid} {...props} type='button'>
      <div
        className={cn('responsive-listbox required', {
          disabled: readOnly,
        })}
      >
        <Button
          plain
          aria-haspopup='dialog'
          name={name}
          className='responsive-listbox__toggler'
          type='button'
          onClick={onChange}
        >
          {value}
        </Button>
      </div>
    </FieldControl>
  );
};

export default VehicleClassFilterCTA;

VehicleClassFilterCTA.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  selectedLabel: PropTypes.string,
  required: PropTypes.bool,
};
